import { useProfile } from '@sdc/auth';
import { useEffect, useRef, useState } from 'react';
import { BoardSheet } from '../components/BoardSheet';
import { BoardStrip } from '../components/BoardStrip';
import { HomePanels } from '../components/HomePanels';
import { NetworkView } from '../components/NetworkView';
import { Splash } from '../components/Splash';
import { SynthwaveBg } from '../components/SynthwaveBg';
import { Topbar } from '../components/Topbar';
import { useAbsences } from '../lib/useAbsences';
import { useAnnouncements } from '../lib/useAnnouncements';
import { usePolls } from '../lib/usePolls';

/**
 * Homescreen = Netzwerk-Ansicht (Design-System §6, Referenz:
 * design/sdc-hub-homescreen-mockup.html).
 */
export function HomePage() {
  const { loading, apps, isAdmin, profile, error } = useProfile();
  const { items: announcements } = useAnnouncements();
  const { polls, reload: reloadPolls } = usePolls();
  const absences = useAbsences();
  const [boardOpen, setBoardOpen] = useState(false);
  const [toast, setToast] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  function showToast(message: string) {
    setToast(message);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setToast(null), 2600);
  }

  if (loading) {
    return (
      <>
        <SynthwaveBg />
        <Splash label="Netzwerk wird aufgebaut …" />
      </>
    );
  }

  return (
    <>
      <SynthwaveBg />
      <Topbar />

      {profile?.is_active === false && (
        <div className="toast is-on" role="alert">
          Dein Account ist deaktiviert. Bitte beim Admin melden.
        </div>
      )}
      {error && (
        <div className="toast is-on" role="alert">
          Profil konnte nicht geladen werden: {error.message}
        </div>
      )}

      <NetworkView apps={apps} isAdmin={isAdmin} onMessage={showToast} />

      {/* Panels und Strip als ein Block am unteren Rand – das Netzwerk hält
          seine Nodes darüber frei (shared/network.ts: NETWORK_BAND). */}
      <div className="dock">
        <HomePanels
          announcements={announcements}
          absences={absences}
          onOpenBoard={() => setBoardOpen(true)}
        />
        <BoardStrip items={announcements} polls={polls} onOpen={() => setBoardOpen(true)} />
      </div>

      <BoardSheet
        items={announcements}
        polls={polls}
        onPollsChanged={reloadPolls}
        isAdmin={isAdmin}
        open={boardOpen}
        onClose={() => setBoardOpen(false)}
      />

      <div className={`toast${toast ? ' is-on' : ''}`} role="status">
        {toast}
      </div>
    </>
  );
}
